<template>
  <div class="file-upload-container"
       :class="{ 'is-multiple': (multiple && ds.uploadFiles && ds.uploadFiles.length > 0) }">
    <template v-if="!visibleAddUploader && ds.uploadFiles && ds.uploadFiles.length > 0">
      <div class="file-upload-content uploaded">
        <div class="file-upload-content-inner uploaded">
          <div class="dz-details">
            <a class="dz-cancel btn_close" @click.stop.prevent="removeAllUploadFiles">
              <img src="../../../../static/img/icon_close.png" width="23" height="23" alt="close">
            </a>
            <div><span class="dz-filename" :class="{link: multiple}" @click.stop.prevent="onClickFileName">
              {{ds.uploadFiles.slice(-1)[0].originalFileName}}<template v-if="ds.uploadFiles.length > 1"> (+{{ds.uploadFiles.length - 1}})</template>
            </span></div>
            <div><span class="dz-size">{{ds.uploadFiles.map(uploadFile => uploadFile.fileSizeByte) | file_size}}</span>
            </div>
            <div><span class="link" v-if="multiple" @click="onClickAdd()">データを追加する</span></div>
          </div>
        </div>
      </div>
    </template>
    <div v-else style="width: 100%;">
      <div v-if="url !== rsUrl" class="ds-type-select-container" style="position: relative;">
        <el-radio v-model="selectedType" name="ds-type" label="local">ローカル</el-radio>
        <el-radio v-model="selectedType" name="ds-type" label="server">サーバ</el-radio>
        <a class="dz-cancel btn_close" style="position: absolute; right: 0;"
           @click.stop.prevent="visibleAddUploader = false"
           v-if="visibleAddUploader && ds.uploadFiles && ds.uploadFiles.length > 0">
          <img src="../../../../static/img/icon_close.png" width="23" height="23" alt="close">
        </a>
      </div>
      <div class="ds-upload-container-inner">
        <el-upload
                v-if="selectedType === 'local'"
                class="file-upload-content"
                ref="uploader"
                :action="url"
                :drag="true"
                :data="additionalData"
                name="file"
                :show-file-list="false"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-progress="handleProgress"
                :on-error="handleError"
                :before-upload="beforeUpload"
                :auto-upload="true"
                :disabled="uploading"
        >
          <div class="file-upload-content-inner uploading" v-if="uploading">
            <div class="dz-details">
              <a class="dz-cancel btn_close" @click.stop.prevent="removeUploadFile">
                <img src="../../../../static/img/icon_close.png" width="23" height="23" alt="close">
              </a>
              <div><span class="dz-filename">{{uploadFileName}}</span></div>
              <div><span class="dz-size">{{uploadFileSizeByte | file_size}}</span></div>
              <div class="dz-progress progress_bar"><span class="dz-upload"
                                                          :style="{ width: uploadProgress + '%' }"></span></div>
            </div>
          </div>
          <div class="file-upload-content-inner" v-else>
            <div class="dz-details">
              <p class="dz-message"><span
                      v-if="visibleAddUploader && ds.uploadFiles && ds.uploadFiles.length > 0">追加の</span>ファイルをドラッグ＆ドロップしてください<br>または<br><a
                      class="link">データを選択する</a></p>
            </div>
          </div>
        </el-upload>
        <form v-else-if="selectedType === 'server'" style="width: 100%;" data-vv-scope="import-form">
          <field-container label="接続先">
            <field-select name="connection_id" v-model="connectionId" noDataText="選択可能な接続先がありません" validate="required"
                          validateLabel="接続先" validateScope="import-form">
              <el-option v-for="connection in connectionSummaries" :label="connection.connectionName"
                         :value="connection.connectionId">{{connection.connectionName}}
              </el-option>
            </field-select>
            <el-button type="primary" @click="onClickConnectionList()" style="margin-left: 12px;">一覧</el-button>
          </field-container>

          <field-container label="インポート方法" v-if="isConnectionType(connectionId, 'db')"
                           tip="インポート方法を指定します。\n\nテーブル：テーブルを指定して全データをインポートします\nSQL：SQLを指定してインポートします\n検索条件やカラムを絞りたい場合はSQLを選択してください。">
            <field-radio-group v-model="databaseImportType" name="database_import_type"
                               :options="[{label: 'テーブル', value: 'table'}, {label: 'SQL', value: 'sql'}]"></field-radio-group>
          </field-container>

          <field-container label="テーブル名" v-if="isConnectionType(connectionId, 'db') && databaseImportType === 'table'">
            <field-input name="upload-ds-import-table" v-model="table" placeholder="" validate="required|max:200"
                         validateLabel="テーブル名" validateScope="import-form"></field-input>
          </field-container>
          <field-container label="SQL" v-if="isConnectionType(connectionId, 'db') && databaseImportType === 'sql'">
            <field-textarea class="field-upload-sql-textarea" name="upload-ds-import-sql" v-model="sql" placeholder=""
                            validate="required" validateLabel="SQL" validateScope="import-form"></field-textarea>
          </field-container>

          <field-container :label="label + 'データ名'" v-if="isConnectionType(connectionId, 'db')">
            <field-input name="source_name" v-model="sourceName" placeholder="ここにテーブル名が入ります" validate="max:100"
                         :validateLabel="label + 'データ名'" validateScope="import-form"></field-input>
          </field-container>

          <field-container label="ファイルパス" v-if="isConnectionType(connectionId, 'file')">
            <field-input name="file_path" v-model="filePath" placeholder="" validate="required|max:500"
                         validateLabel="ファイルパス" validateScope="import-form"></field-input>
          </field-container>
          <field-container :label="label + 'データ名'" v-if="isConnectionType(connectionId, 'file')">
            <field-input name="source_name" v-model="sourceName" placeholder="ここにファイル名が入ります" validate="max:100"
                         :validateLabel="label + 'データ名'" validateScope="import-form"></field-input>
          </field-container>

          <div style="display: flex; justify-content: center;">
            <el-button type="primary" @click="onClickImport()" style="width: 288px;">インポート</el-button>
          </div>
        </form>
      </div>
    </div>
    <upload-file-list v-if="visibleUploadFileList" :uploadFiles="ds.uploadFiles"
                      :method="method" :modelId="modelId" :label="label" @change="onChangeUploadFileList"
                      @close="visibleUploadFileList = false">
    </upload-file-list>

    <connection-list v-if="visibleConnectionList" @close="onCloseConnectionList"></connection-list>
  </div>
</template>

<script lang="js">
import { default as ApiApiClient } from '../../../api/api'
import MessageBox from '../../../utils/message-box'
import Messages from '../../../utils/messages'
import CommonUtil from '../../../utils/common'
import { Code } from '../../../api/base'
import ConnectionSettingDialogCmp from '../../connection/dialogs/connection-setting.vue'
import ConnectionListDialogCmp from '../../connection/dialogs/connection-list.vue'
import UploadFileListDialogCmp from './upload-ds/dialogs/upload-file-list.vue'
import WebApiClient from '../../../api/web'

export default {
  name: 'FieldUploadDsCmp',
  components: {
    'connection-setting': ConnectionSettingDialogCmp,
    'connection-list': ConnectionListDialogCmp,
    'upload-file-list': UploadFileListDialogCmp
  },
  props: {
    ds: null,
    maxFileSize: {type: Number, default: (1024 * 1024 * 500)},
    url: {type: String, default: ''},
    method: '',
    modelId: '',
    multiple: {type: Boolean, default: false},
    hasPossibility: Boolean
  },
  model: {
    prop: 'ds',
    event: 'change'
  },
  data () {
    return {
      label: {
        train: '学習',
        update: '学習',
        predict: '適用',
        convert: '変換',
        evaluate_predict: '評価'
      }[this.method],
      uploading: false,
      uploadProgress: 0,
      uploadFileName: '',
      uploadFileSizeByte: 0,
      uploadingFile: null,

      visibleAddUploader: false,

      selectedType: 'local',
      connectionId: '',
      sourceName: '',
      table: '',
      sql: '',
      databaseImportType: 'table',
      filePath: '',

      visibleUploadFileList: false,
      visibleConnectionList: false,

      connectionSummaries: []
    }
  },
  computed: {
    dsUrl () {
      return `${this.$session.get('API_URL')}ds/put`
    },
    rsUrl () {
      return `${this.$session.get('API_URL')}rs/put`
    },
    additionalData () {
      let data = {
        key: this.$session.get('API_KEY'),
        secret: this.$session.get('API_SECRET'),
        channel: '1',
        method: this.method
      }

      if (/(predict)|(update)/.test(this.method)) {
        data = Object.assign({
          model_id: this.modelId
        }, data)
      }

      if (/(train)|(update)/.test(this.method)) {
        data = Object.assign({
          estimate: !this.hasPossibility
        }, data)
      }

      return data
    }
  },
  mounted () {
    this.refreshConnections()
  },
  watch: {
    url (newUrl) {
      if (newUrl === this.rsUrl) {
        this.selectedType = 'local'
      }

      for (let i = 0, len = this.ds.uploadFiles.length; i < len; i++) {
        this.removeUploadFile(0)
      }
    },

    selectedType (newSelectedType) {
      this.initImportSetting()
    },

    connectionId (newConnectionId) {
      this.table = ''
      this.sql = ''
      this.filePath = ''
      this.databaseImportType = 'table'
    }
  },
  methods: {
    refreshConnections () {
      WebApiClient.getConnections(this).then(response => {
        this.connectionSummaries = response.data.result.connections
        this.$forceUpdate()
      })
    },

    initImportSetting () {
      this.connectionId = ''
      this.sourceName = ''
      this.table = ''
      this.sql = ''
      this.filePath = ''
      this.databaseImportType = 'table'
    },
    onChangeUploadFileList (newUploadFiles) {
      const oldDs = this.ds
      const oldUploadFiles = oldDs.uploadFiles

      const removedUploadFiles = []
      const addedUploadFiles = []
      for (const oldUploadFile of oldUploadFiles) {
        if (newUploadFiles.indexOf(oldUploadFile) < 0) {
          removedUploadFiles.push(oldUploadFile)
        }
      }
      for (const newUploadFile of newUploadFiles) {
        if (oldUploadFiles.indexOf(newUploadFile) < 0) {
          addedUploadFiles.push(newUploadFile)
        }
      }

      if (CommonUtil.isNotEmpty(removedUploadFiles) || CommonUtil.isNotEmpty(addedUploadFiles)) {
        const ds = this.url !== this.rsUrl ? {
          dsName: (CommonUtil.isNotEmpty(newUploadFiles) && newUploadFiles.length === 1)
            ? newUploadFiles[0].dsName
            : '',
          uploadFiles: newUploadFiles,
          header: oldDs.header
        } : null
        this.$emit('change', ds)

        for (const removedUploadFile of removedUploadFiles) {
          this.$emit('removed', ds, removedUploadFile)
        }
        for (const addedUploadFile of addedUploadFiles) {
          this.$emit('added', ds, addedUploadFile)
        }
      }
    },
    onClickAdd () {
      this.initImportSetting()
      this.visibleAddUploader = true
    },
    isConnectionType (connectionId, type) {
      if (CommonUtil.isEmpty(connectionId)) {
        return false
      }

      const TYPES = {
        'db': ['postgresql', 'mysql', 'redshift'],
        'file': ['ftp', 'sftp']
      }

      const connectionType = this.connectionSummaries.filter(
        (connection) => { return connectionId === connection.connectionId })[0].type
      return TYPES[type].indexOf(connectionType) >= 0
    },
    onClickFileName () {
      if (this.multiple) {
        this.visibleUploadFileList = true
      }
    },
    removeAllUploadFiles () {
      if (this.ds.uploadFiles.length > 1) {
        MessageBox.confirm(this, `選択した${this.label}データを全て削除しますか？`).then(() => {
          this.removeAllUploadFilesInner()
        })
      } else {
        this.removeAllUploadFilesInner()
      }
    },
    removeAllUploadFilesInner () {
      this.visibleAddUploader = false
      for (let i = 0, len = this.ds.uploadFiles.length; i < len; i++) {
        this.removeUploadFile(0)
      }
    },
    removeUploadFile (index = -1) {
      if (index >= 0) {
        this.visibleAddUploader = false
        const uploadFiles = this.ds.uploadFiles
        const removedUploadFile = uploadFiles.splice(index, 1)[0]
        const ds = this.url !== this.rsUrl ? {
          dsName: uploadFiles.length === 1 ? uploadFiles[0].dsName : '',
          uploadFiles: uploadFiles,
          header: uploadFiles.length > 0 ? this.ds.header : []
        } : null

        const rs = this.url === this.rsUrl ? {
          dsName: uploadFiles.length === 1 ? uploadFiles[0].dsName : '',
          uploadFiles: uploadFiles,
          rsName: uploadFiles.length > 0 ? this.ds.rsName : null,
          rsCount: uploadFiles.length > 0 ? this.ds.rsCount : null
        } : null

        this.$emit('change', ds || rs)
        this.$emit('removed', ds || rs, removedUploadFile)
        this.$forceUpdate()
      } else {
        if (this.uploading) {
          const uploader = this.$refs.uploader
          if (this.uploading && CommonUtil.isNotNull(this.uploadingFile)) {
            uploader.abort(this.uploadingFile)
          }

          this.uploading = false
          this.uploadFileName = ''
          this.uploadFileSizeByte = 0
          this.uploadProgress = 0
          this.uploadingFile = null
        }
      }
    },
    handleRemove (file, fileList) {
      this.removeUploadFile()
    },
    handleChange (file, fileList) {
      const fileStatus = file.status
      if (fileStatus === 'ready') {
        this.uploading = true
        this.uploadFileName = file.name
        this.uploadFileSizeByte = file.size
        this.uploadingFile = file
      } else if (fileStatus === 'success') {
        const response = file['response']
        if (response.code === Code.SUCCESS) {
          this.handleSuccess(response, file, fileList)
        } else {
          this.alertError(response.code, null, response.message_args)
        }
      }
    },
    handleProgress (event, file, fileList) {
      this.uploadProgress = event.percent
    },
    handleSuccess (response, file, fileList) {
      const uploadFiles = this.ds.uploadFiles
      const addedUploadFile = {
        dsName: response.ds_name,
        fileSizeByte: this.uploadFileSizeByte,
        fileName: this.uploadFileName,
        originalDsName: response.ds_name,
        originalFileName: this.uploadFileName,
        originalFileSizeByte: this.uploadFileSizeByte,
        importId: response.import_id,
        importedAt: response.imported_at
      }
      uploadFiles.push(addedUploadFile)
      const ds = this.url !== this.rsUrl ? {
        dsName: uploadFiles.length > 1 ? '' : response.ds_name,
        uploadFiles: uploadFiles,
        header: response.header
      } : null

      const rs = this.url === this.rsUrl ? {
        dsName: uploadFiles.length > 1 ? '' : response.ds_name,
        uploadFiles: uploadFiles,
        rsName: response.rs_name,
        rsCount: response.rs_count
      } : null

      this.uploading = false
      this.uploadFileName = ''
      this.uploadFileSizeByte = 0
      this.uploadProgress = 0
      this.uploadingFile = null
      this.$refs.uploader.clearFiles()
      this.visibleAddUploader = false
      this.$emit('change', ds || rs)
      this.$emit('added', ds || rs, addedUploadFile, response.possibilities)
    },
    handleError (err, file, fileList) {
      this.alertError()
    },
    alertError (code = '', defaultErrorMessage = 'ファイルのアップロードに失敗しました。', messageArgs = null) {
      if (CommonUtil.isEmpty(messageArgs)) messageArgs = []
      messageArgs.splice(0, 0, this.label)
      const message = CommonUtil.isNotEmpty(code) ? Messages.getMessage(code, messageArgs) : null
      MessageBox.alert(this, message || defaultErrorMessage, {
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.removeUploadFile()
      })
    },
    beforeUpload (file) {
      const uploadFile = {
        dsName: null,
        fileSizeByte: file.size,
        fileName: file.name
      }
      this.$emit('before-add', this.ds, uploadFile)
      if (file.size > this.maxFileSize) {
        MessageBox.alert(this, 'ファイルのサイズが上限(500MB)を超えています。').then(() => {
          this.removeUploadFile()
        })
        return false
      }
      // TODO csv zip upload
      return true
    },
    onCloseConnectionList () {
      this.visibleConnectionList = false
      this.refreshConnections()
    },

    onClickConnectionList () {
      this.visibleConnectionList = true
    },
    onClickImport () {
      this.$validator.validateAll('import-form').then((result) => {
        if (result) {
          let table = ''
          let sql = ''
          let filePath = ''

          if (this.selectedType === 'server') {
            if (this.isConnectionType(this.connectionId, 'db')) {
              if (this.databaseImportType === 'table') {
                table = this.table
              } else {
                sql = this.sql
              }
            } else {
              filePath = this.filePath
            }
          }

          ApiApiClient.importDs(this, {
            method: this.method,
            modelId: this.modelId,
            connectionId: this.connectionId,
            sourceName: this.sourceName,
            table: table,
            sql: sql,
            filePath: filePath
          }).then((response) => {
            if (response.data.code === Code.SUCCESS) {
              this.handleSuccessImport(response)
            } else {
              if (/^21\d{2}$/.test(response.data.code)) {
                this.alertError(response.data.code, 'インポートに失敗しました。', response.data.message_args)
              }
            }
          }).catch(() => {})
        }
      })
    },
    handleSuccessImport (response) {
      const addedUploadFile = {
        dsName: response.data.ds_name,
        fileSizeByte: response.data.file_size_byte,
        fileName: response.data.file_name,
        originalDsName: response.data.ds_name,
        originalFileName: response.data.file_name,
        originalFileSizeByte: response.data.file_size_byte,
        importId: response.data.import_id,
        importedAt: response.data.imported_at
      }

      const uploadFiles = this.ds.uploadFiles
      uploadFiles.push(addedUploadFile)
      const ds = {
        dsName: uploadFiles.length > 1 ? '' : response.data.ds_name,
        uploadFiles: uploadFiles,
        header: response.data.header
      }
      this.uploading = false
      this.uploadFileName = ''
      this.uploadFileSizeByte = 0
      this.uploadProgress = 0
      this.uploadingFile = null
      this.visibleAddUploader = false
      this.$emit('change', ds)
      this.$emit('added', ds, addedUploadFile)
      this.initImportSetting()
      this.$forceUpdate()
    }
  }
}

</script>

<style scoped>
  .file-upload-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  /* ------------------------------------------------------- */
  .file-upload-content {
    width: 100%;
    height: 190px;
    line-height: 1;
    margin: 0;
  }

  .file-upload-content + .file-upload-content {
    margin-top: 16px;
  }

  .file-upload-content.uploaded {
    border: solid 3px #fff;
    border-radius: 6px;
  }

  .file-upload-container >>> .el-upload {
    width: inherit;
    height: inherit;
  }

  .file-upload-container >>> .el-upload > .el-upload-dragger {
    width: inherit;
    height: inherit;
    border: dashed 3px #fff;
    background-color: transparent;
  }

  .file-upload-container >>> .el-upload > .el-upload-dragger:hover {
    border-color: #2456d4;
  }

  .file-upload-container.disabled >>> .el-upload > .el-upload-dragger {
    cursor: default;
  }

  .file-upload-container.disabled >>> .el-upload > .el-upload-dragger .file-upload-content-inner {
    padding: 0;
    border: none;
  }

  .file-upload-content-inner {
    background: #e2f1f6;
    padding: 30px 20px;
    text-align: center;
    color: #394445;
  }

  .file-upload-content-inner .dz-details {
    font-size: 0.88rem;
    text-align: center;
    background: url(../../../../static/img/icon_file.png) no-repeat center top;
    background-size: 24px 30px;
    padding: 38px 0 0 0;
    margin: 0;
    line-height: 2;
  }

  .file-upload-content-inner .dz-details {
    position: relative;
  }

  .file-upload-content-inner .dz-filename {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .file-upload-content-inner .dz-cancel.btn_close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }

  .file-upload-content-inner .dz-cancel.btn_close:hover {
    opacity: 0.7;
  }

  .progress_bar {
    display: block;
    width: 100%;
    height: 2px;
    margin: 24px 0 0 0;
    background: #fff;
  }

  .progress_bar span {
    display: block;
    background: #6ba7ef;
    width: 40%;
    height: 2px;
  }

  .field-upload-sql-textarea >>> textarea {
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/upload-ds.vue